import { BrowserUserTimingStrategy } from "@storyboard/web-logger/timings/BrowserUserTimingStrategy";
import { ConsoleLogTimingStrategy } from "@storyboard/web-logger/timings/ConsoleLogTimingStrategy";
import { OtelTimingStrategy } from "@storyboard/web-logger/timings/OtelTimingStrategy";
import { Timings } from "@storyboard/web-logger/timings/Timings";
import type { TimingStrategy } from "@storyboard/web-logger/types";
import { type FlagData, onFlagsChanged } from "@/config";
import { createLogger } from "@/logger";

const log = createLogger("telemetry");

export function initializeTimings() {
  onFlagsChanged(applyTimingStrategies);
}

function applyTimingStrategies(flags: FlagData) {
  const strategies: TimingStrategy[] = [new BrowserUserTimingStrategy()];
  // OTel timings ship by default (head-sampled per category) instead of being gated behind the
  // old `Timings.Honeycomb` flag; the global telemetry kill switch still disables them.
  if (!flags.inActiveTelemetry) {
    strategies.push(new OtelTimingStrategy());
  }
  if (flags["Timings.ConsoleLog"]) {
    strategies.push(new ConsoleLogTimingStrategy());
  }
  log.debug("Timing strategies updated", strategies);
  Timings.setStrategies(strategies);
}
